import { useEffect } from 'react';
import { NavMarker } from 'react-rhumb';
import Raven from 'raven-js';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FullPageError = ({
  error
}) => {
  useEffect(() => {
    Raven.captureException(new Error('Full page error', {
      cause: error
    }));
  }, [error]);
  return /*#__PURE__*/_jsxs(ErrorMessage, {
    type: "badRequest",
    children: [/*#__PURE__*/_jsx(NavMarker, {
      name: "FULL_PAGE_ERROR"
    }), /*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "index.errorBoundaries.fullPage.refreshWithLink",
        options: {
          refreshLink: /*#__PURE__*/_jsx(Link, {
            href: window.location.href,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "index.errorBoundaries.fullPage.refreshLink"
            })
          })
        }
      })
    })]
  });
};
export default FullPageError;